import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink, faSliders, faBell, faCircleInfo } from '@fortawesome/free-solid-svg-icons';

const GUIDE_STEPS = [
    {
        icon: faLink,
        iconColor: '#7C3AED',
        iconBg: '#EDE9FE',
        title: 'Dán link sản phẩm',
        desc: 'Vào Shopee / Lazada / TikTok, copy link sản phẩm bất kỳ và dán vào ô tìm kiếm.',
    },
    {
        icon: faSliders,
        iconColor: '#0284C7',
        iconBg: '#E0F2FE',
        title: 'Đặt ngưỡng thông báo',
        desc: 'Nhấn 🔔 trên kết quả sản phẩm, chọn mức giảm % hoặc giá mục tiêu cụ thể.',
    },
    {
        icon: faBell,
        iconColor: '#16A34A',
        iconBg: '#F0FDF4',
        title: 'Nhận thông báo tự động',
        desc: 'Hệ thống kiểm tra giá định kỳ và thông báo ngay khi giá đạt ngưỡng bạn đặt.',
    },
];

/** Hướng dẫn sử dụng 3 bước — luôn hiển thị ở cuối trang */
function PriceWatchGuideSection() {
    return (
        <div className="bg-surface rounded-xl border border-line p-4 flex flex-col gap-3 mt-2">
            <div className="flex items-center gap-2 pb-3 border-b border-line">
                <FontAwesomeIcon icon={faCircleInfo} className="text-primary-500 text-sm" />
                <span className="text-sm font-bold text-primary-600">Cách sử dụng</span>
            </div>

            {GUIDE_STEPS.map((step, i) => (
                <div key={step.title} className="flex gap-3 items-start">
                    <div
                        className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0"
                        style={{ backgroundColor: step.iconBg }}
                    >
                        <FontAwesomeIcon icon={step.icon} style={{ color: step.iconColor }} className="text-base" />
                    </div>
                    <div className="flex flex-col gap-0.5">
                        <span className="text-xs font-bold">{i + 1}. {step.title}</span>
                        <span className="text-xs text-content-3">{step.desc}</span>
                    </div>
                </div>
            ))}

            <div className="bg-surface-sunken rounded-lg px-3 py-2">
                <span className="text-xs text-content-3">
                    💡 Mỗi tài khoản có thể theo dõi tối đa{' '}
                    <span className="font-semibold text-content-2">20 sản phẩm</span> cùng lúc.
                </span>
            </div>
        </div>
    );
}

export default PriceWatchGuideSection;
